export default __webpack_public_path__ + "static/media/sign-in-background.d158d42f.svg";